module.exports = __webpack_public_path__ + "img/georgian-w.30dff0b4.svg";